import { Overlay } from "ol";
import { toLonLat, fromLonLat } from "ol/proj.js";
import * as geoServerServices from "./Services/GeoServerServices";
import {
  calculateCo2StorageByDimensions,
  cmToMeter,
} from "./co2calculator";
import { transform } from "ol/proj.js";
import { treeFinder } from "./treeFinderv2";

const schliessePopup = document.getElementById("popup-closer");
const popupHTMLElement = document.getElementById("popup");
const popupContentHTMLElement = document.getElementById("popup-content");
const baumberaterHTMLElement = document.getElementById("baumberater");
const baumberatercontentHTMLElement =
  document.getElementById("Baumberatercontent");

let karte = null;
let popupOverlay = null;

export function initializePopups(map) {
  karte = map;

  popupOverlay = erstellePopUpOverlay();
  karte.addOverlay(popupOverlay);

  karte.on("singleclick", onClickKarte);
  karte.on("pointermove", aendereZeigerWennMausUeberFeature);

  schliessePopup.onclick = zuruecksetzenPopupAnzeige;
}

function erstellePopUpOverlay() {
  return new Overlay({
    element: popupHTMLElement,
    positioning: "bottom-center",
    stopEvent: false,
    autoPan: {
      animation: { duration: 250 },
    },
  });
}

const onClickKarte = async (evt) => {
  let feature = ermittleFeatureVonKarte(evt.pixel);
  const baumBerater = true;

  const coordinate = evt.coordinate;

  // Falls du Längen- und Breitengrad (EPSG:4326) brauchst:
  const lonLat = toLonLat(coordinate);

  //################BaumBerater
  if (baumBerater) {
    //treeFinder(coordinate);
    //baumberaterHTMLElement.style.visibility = "visible";
  } else
  {
    //baumberaterHTMLElement.style.visibility = "hidden";
  }

  // Prüfe Ob Feature ein Baum ist
  // Prüfen auf Feature Values Lokalnummer als Attribute, damit Kein Popup bei Messungen erscheint

  // Prüfe Ob Feature eine Flaeche ist
  if (
    feature &&
    feature.values_ != null &&
    feature.values_.type != null &&
    feature.values_.type === "Flaeche"
  ) {
    const popupContent = erstelleFlaechePopup(feature);
    zeigeFeaturePopupAn(evt, popupContent, feature);
  } else if (feature && feature.values_ != null && feature.values_.id != null) {
    feature = await geoServerServices.fetchTreeById(
      feature.values_.id
    );
    const popupContent = erstelleBaumPopup(feature);
    zeigeFeaturePopupAn(evt, popupContent, feature);
  }
};

const ermittleFeatureVonKarte = (pixel) =>
  karte.forEachFeatureAtPixel(pixel, (feature) => feature);

const erstelleBaumPopup = (feature) => {
  const htmlULPreString = `<ul class='list-group'>`;
  const htmlULPostString = `</ul>  `;
  const htmlLIHeaderPre = `<li class="list-group-item active">Baum Eigenschaften`;
  const htmlLIPreString = `<li class='list-group-item d-flex justify-content-between align-items-center'>`;
  const htmlLIPostString = `</li>`;
  const htmlSPANPreString = `<span class='badge badge-primary badge-pill'>`;
  const htmlSPANPostString = `</span>`;

  let popupContent = htmlULPreString + htmlLIHeaderPre + htmlSPANPreString;

  if (feature.properties) {
    // Berechne Co2 SPeicherung Pro Baum
    let singleTreeCo2Save = calculateCo2StorageByDimensions(
      feature.properties.hoehe,
      cmToMeter(feature.properties.umfang),
      feature.properties.baumart
    );

    //CoSpeicher Wert an Liste anhängen
    Object.assign(feature.properties, {
      "Kohlenstoff Speicherung (t)": singleTreeCo2Save.toFixed(2),
    });

    // Baue PopUp Entries auf
    const entries = Object.entries(feature.properties);
    popupContent += entries.length + htmlSPANPostString + htmlLIPostString;

    entries.forEach(([key, value]) => {
      popupContent += `${htmlLIPreString}${key}: ${value}${htmlLIPostString}`;
    });
  }

  popupContent += htmlULPostString;

  return popupContent;
};

const erstelleFlaechePopup = (feature) => {
  const htmlULPreString = `<ul class='list-group'>`;
  const htmlULPostString = `</ul>  `;
  const htmlLIHeaderPre = `<li class="list-group-item active">Fläche Eigenschaften`;
  const htmlLIPreString = `<li class='list-group-item d-flex justify-content-between align-items-center'>`;
  const htmlLIPostString = `</li>`;
  const htmlSPANPreString = `<span class='badge badge-primary badge-pill'>`;
  const htmlSPANPostString = `</span>`;

  let popupContent = htmlULPreString + htmlLIHeaderPre + htmlSPANPreString;

  if (feature.values_ && feature.values_.eigenschaften) {
    const entries = Object.entries(feature.values_.eigenschaften);
    popupContent += entries.length + htmlSPANPostString + htmlLIPostString;

    entries.forEach(([key, value]) => {
      popupContent += `${htmlLIPreString}${key}: ${value}${htmlLIPostString}`;
    });
  }

  popupContent += htmlULPostString;

  return popupContent;
};

const zeigeFeaturePopupAn = (evt, popupContent, feature) => {
  // Koordinaten von Feature PSG transformieren
  var coordinatesTransform = transform(
    [feature.bbox[0], feature.bbox[1]],
    "EPSG:4326",
    "EPSG:3857"
  );

  popupOverlay.setPosition(coordinatesTransform);
  popupContentHTMLElement.innerHTML = popupContent;
};

export const zuruecksetzenPopupAnzeige = () => {
  if (popupOverlay) {
    popupOverlay.setPosition(undefined);
    schliessePopup.blur();
  }
};

const aendereZeigerWennMausUeberFeature = (evt) => {
  const pixel = karte.getEventPixel(evt.originalEvent);
  const hit = karte.hasFeatureAtPixel(pixel);
  karte.getTarget().style.cursor = hit ? "pointer" : "";
};
